/* 🤖 this file was generated by svg-to-ts */

import type { PorIconModel } from './build/PorIcon.Model';

export type PorIconModelNameSubset<T extends Readonly<PorIconModel[]>> = T[number]['name'];

export * from './build/PorIcon-caretdown.icon';
export * from './build/PorIcon-check.icon';
export * from './build/PorIcon-chevronleft.icon';
export * from './build/PorIcon-chevronright.icon';
export * from './build/PorIcon-circleclose.icon';
export * from './build/PorIcon-cross.icon';
export * from './build/PorIcon-email.icon';
export * from './build/PorIcon-errorMail.icon';
export * from './build/PorIcon-favorites.icon';
export * from './build/PorIcon-info.icon';
export * from './build/PorIcon-lock.icon';
export * from './build/PorIcon-magnifier.icon';
export * from './build/PorIcon-openinnew.icon';
export * from './build/PorIcon-satellite.icon';
export * from './build/PorIcon-spinner.icon';
export * from './build/PorIcon-train.icon';
export * from './build/PorIcon.Model';
